import React from 'react'
import { Button, BreadcrumbGroup, Spinner, Modal } from 'AWS-UI-Components-React'
import './ContractDetailsView.css'
import moment from 'moment'

export default class ContractView extends React.Component {

    render() {
        const { contract } = this.props;
        if (!contract ) {
            return <div className="awsui-util-t-c"><Spinner size="large"></Spinner></div>
        } else {
        return (
            <div className="contract-page">
                {this.renderModal()}
                {this.renderBreadcrumb(contract.versionNumber)}
                <div className="contract-page-outer-container">
                    <div className="contract-page-inner-container">
                        <div className="details-container">
                            <div>
                                <p>Version number: {contract.versionNumber}</p>
                                <p>Current: 
                                    {contract.active 
                                        ? <strong> YES </strong> 
                                        : <span><strong> no </strong><Button id="activate-button" variant="link" onClick={() => this.props.handleModalDisplay(true)}>(Activate)</Button></span>
                                    }
                                </p>
                            </div>
                            <div>
                                <p>Created: {this.convertToUTCFullDate(contract.createdAt)}</p>
                                <p>Updated: {this.convertToUTCFullDate(contract.updatedAt)}</p>
                            </div>
                        </div>
                        <div className="scrollable-terms awsui-util-mt-l awsui-util-p-l">
                            <h2 className="title awsui-util-mt-xs awsui-util-mb-s">Terms and Conditions</h2>
                            <p dangerouslySetInnerHTML={{ __html: contract.contract }} />
                            <p>
                                <strong>Version:</strong> {contract.versionNumber}
                                <br />
                                <strong>Created:</strong> {this.convertToUTCDate(contract.createdAt)}
                                <br />
                                <strong>Updated:</strong> {this.convertToUTCDate(contract.updatedAt)}
                            </p>
                        </div>
                    </div>
                </div>
                <Button className="awsui-util-mt-s" variant="link" text="Back" href="/#/contracts"></Button>
            </div>
        )
        }
    }

    renderModal() {
        return (
            <Modal
                content={"Are you sure you want to set this contract as the current active contract?"}
                visible={this.props.modalVisible}
                header="Confirmation"
                footer={
                    <span className="awsui-util-f-r">
                        <Button id="cancel_modal_button" variant="link" text="Cancel" onClick={() => this.props.handleModalDisplay(false)}></Button>
                        <Button id="submit_modal_button" variant="primary" text="Yes" onClick={() => this.props.handleModalConfirmClick(this.props.contract.id)}></Button>
                    </span>
                }
            ></Modal>
        )
    }

    renderBreadcrumb(versionNumber) {
        const items = [
            {
                "text": "Contracts",
                "href": "/#/contracts"
            },
            {
                "text": versionNumber,
                "href": "/"
            }
        ]
        return <BreadcrumbGroup label="Breadcrumbs" items={items}></BreadcrumbGroup>
    }

    convertToUTCDate(date) {
        return moment(date).format('YYYY-MM-DD')
    }

    convertToUTCFullDate(date) {
        return new Date(date).toUTCString()
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/Details/ContractDetailsView.jsx